import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { X } from 'lucide-react';

const STORAGE_KEY = 'kmfc_app_popup_visits';
const SHOW_EVERY = 3; // toon elke 3 bezoeken

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 99999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 0 24px;
`;

const Sheet = styled.div`
  background: #1a1a1a;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 20px;
  width: calc(100% - 32px);
  max-width: 420px;
  padding: 24px 20px 20px;
  box-shadow: 0 -8px 40px rgba(0,0,0,0.6);
  animation: ${slideUp} 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;

const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const AppIcon = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f97316, #ea580c);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
`;

const CloseBtn = styled.button`
  background: rgba(255,255,255,0.08);
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  cursor: pointer;
  color: rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  &:hover { background: rgba(255,255,255,0.14); color: #fff; }
`;

const Body = styled.div`
  font-size: 15px;
  color: rgba(255,255,255,0.85);
  line-height: 1.6;
  margin-bottom: 20px;

  strong { color: #fff; }
`;

const DownloadBtn = styled.a`
  display: block;
  width: 100%;
  padding: 13px;
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  letter-spacing: -0.01em;
  transition: filter 0.15s;
  &:hover { filter: brightness(0.92); }
`;

const SkipBtn = styled.button`
  display: block;
  width: 100%;
  padding: 11px;
  background: transparent;
  color: rgba(255,255,255,0.4);
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  &:hover { color: rgba(255,255,255,0.7); }
`;

export default function AppDownloadPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Alleen op mobiel
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
    if (!isMobile) return;

    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <Overlay onClick={() => setShow(false)}>
      <Sheet onClick={e => e.stopPropagation()}>
        <TopRow>
          <AppIcon>📱</AppIcon>
          <CloseBtn onClick={() => setShow(false)}><X size={14} /></CloseBtn>
        </TopRow>
        <Body>
          De website is niet geoptimaliseerd voor mobiele telefoons, download de app.
        </Body>
        <DownloadBtn
          href="https://testflight.apple.com/join/RnJhY2Bz"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setShow(false)}
        >
          Download via TestFlight
        </DownloadBtn>
        <SkipBtn onClick={() => setShow(false)}>Sluiten</SkipBtn>
      </Sheet>
    </Overlay>
  );
}
